// LineChartComponent.tsx
import { LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer } from 'recharts';
import { lineChartData } from '../../../data/ChartData';

const LineChartComponent = () => {
  return (
    <ResponsiveContainer width='100%' height={300}>
      <LineChart data={lineChartData}>
        <CartesianGrid strokeDasharray='3 3' />
        <XAxis dataKey='year' />
        <YAxis />
        <Tooltip />
        <Line type='monotone' dataKey='value' stroke='#52bf92' strokeWidth={2} dot={{ r: 4 }} />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default LineChartComponent;
